<template>
  <Modal v-if="show">
    <template slot="header">
      <h3 class="modal-title">
        Regulamin
      </h3>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="close"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <div class="cb-container">
        <md-checkbox v-model="agreed" />
        <div>
          Oświadczam, że zapoznałem/am się i akceptuję warunki Regulaminu oraz,
          że zapoznałem/am się z, zawartą w
          <a :href="rulesUrl" target="_blank">Regulaminie</a>, informacją o
          dystrybutorze i zgadzam się na jej przekazanie za pośrednictwem
          niniejszego serwisu.
          <p class="note">
            * Korzystanie z usług dostępnych w serwisie jest
            <strong>bezpłatne</strong> i nie powoduje zaciągnięcia żadnych
            zobowiązań względem właściciela serwisu.
          </p>
        </div>
      </div>
    </template>
    <template slot="footer">
      <md-button :disabled="!agreed" @click="nextStep" class="lp-btn md-info">
        Dalej
      </md-button>
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal'
import { mapState } from 'vuex'
export default {
  name: 'HomeModal',
  components: {
    Modal,
  },
  data() {
    return {
      agreed: false,
      show: false,
    }
  },
  computed: {
    ...mapState({
      rulesUrl: state => state.rulesDocUrl,
    }),
  },
  methods: {
    nextStep() {
      this.$ga.enable()
      this.$router.push('/date' + this.$store.state.query)
    },
    close() {
      this.show = false
    },
    open() {
      this.show = true
    },
  },
}
</script>

<style scoped lang="scss">
.modal-title {
  color: #3c4858;
}
.cb-container {
  margin-top: 10px;
  text-align: justify;
  display: flex;
  align-items: flex-start;
  & > div:last-child {
    margin-top: 10px;
  }
  a {
    cursor: pointer;
  }
}
.note {
  margin-top: 15px;
  font-size: 12px;
  line-height: 1.3em;
}
</style>
